export enum SocialAccountTypes {
	Instagram = 0,
}
